import {
  Grid,
  Stack,
  Box,
  Typography,
  Icon,
  Chip,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  Button,
} from "@mui/material";
import {
  BusinessCenter as BusinessCenterIcon,
  LogoutOutlined,
  AccountCircle,
  ArrowBack,
} from "@mui/icons-material";

import axios from "axios";
import { AuthContext } from "../index";
import { GlobalDataContext } from "../index";
import { useContext, useEffect, useState } from "react";

import getImage, { getImageV2 } from "../utils/getImage";
import ItemsList from "./ItemsList";
import ItemsListV2 from "./ItemsListV2";
import Chat from "./Chat";
import App from "./App";
import { now } from "../utils/dateTime";

const ChatScreen = () => {
  const [view, setView] = useState("account");
  const [servicesStatus, setServicesStatus] = useState("active");
  const [servicePicked, setServicePicked] = useState(null);
  const { onLogout, id, phoneNumber, userId, role } = useContext(AuthContext);
  const { messages, handleSendMessage } = useContext(GlobalDataContext);

  const [services, setServices] = useState({
    isLoaded: false,
    data: [],
  });

  const fillById = (id, arr = []) => {
    const ix = arr.findIndex((it) => it.id == id);
    if (ix != -1) {
      return arr[ix];
    }

    return { id };
  };

  // const fillServices = (services = [], serviceTemplates = [], allLocations = []) => {
  //     return services.map(s => ({
  //         ...s,
  //         serviceTemplate: fillById(s.serviceTemplate.id, serviceTemplates),
  //         location: fillById(s.location.id, allLocations)
  //     }))
  // };

  const fillByParentId = (groupedLogs = [], services = []) => {
    return groupedLogs.map((it) => ({
      ...it,
      service: fillById(it.parentId, services),
    }));
  };

  const groupLogs = (logs) => {
    return logs.reduce((acc, curr) => {
      const idx = acc.findIndex(
        (it) => it.parentId === curr.parentId && it.logType === curr.logType,
      );

      if (idx != -1) {
        acc[idx].logs.push(curr);
      } else {
        acc.push({
          parentId: curr.parentId,
          logType: curr.logType,
          logs: [curr],
        });
      }

      return acc;
    }, []);
  };

  const [logs, setLogs] = useState({
    isLoaded: false,
    data: [],
  });

  async function loadLogs() {
    // const [ serviceTemplates, allLocations ] = await Promise.all([loadServiceTemplates(), loadAllLocations()]);

    let url = `/api/v1/logs/get`;
    let groupedLogs = [];

    try {
      const resp = await axios.post(url, {});
      groupedLogs = groupLogs(resp.data);
    } catch (err) {
      throw err;
    }

    try {
      const resp = await axios.post(`/api/v1/services/get`, {
        userIds: [id],
        ids: groupedLogs
          .filter((it) => it.logType === "service_message")
          .map((it) => it.parentId),
      });
    } catch (err) {
      throw err;
    }

    setLogs({ isLoaded: true, data: [...fillByParentId(groupedLogs)] });
  }

  useEffect(() => {
    loadLogs();
  }, []);

  const handleAddLog = (parentId, userId, message, callback) => {
    try {
      const resp = axios.post(`/api/v1/logs`, {
        logType: "service_message",
        message: message,
        parentId: parentId,
        userId: id,
      });
    } catch (err) {
      throw err;
    }

    callback();
  };

  const handleServicePick = (service) => {
    setServicePicked(service);
    setView("detailed");
  };

  const getServices = (status) => {
    if (status == "active") {
      return services.data.filter((s) => {
        return s;
        // return s.logs.indexOf(log => log.message == 'CANCELLED') == -1
      });
    }

    if (status == "notactive") {
      return services.data;
      // return services.data.filter(s => s.logs.indexOf(log => log.message == 'CANCELLED') != -1);
    }

    return [];
  };

  const getView = () => {
    let element = null;

    if (view == "account") {
      element = (
        <Box
          sx={{
            backgroundColor: "rgb(0 0 0/0.05)",
          }}
        >
          <Box
            sx={{
              borderRadius: "20px",
              backgroundColor: "rgb(255 255 255)",
              mb: "10px",
              pb: "5px",
            }}
          >
            <Box sx={{ pt: 10 }}>
              <AccountCircle
                sx={{ fontSize: "100px", color: "rgb(0 0 0/0.15)" }}
              />
            </Box>
            <Box sx={{ p: 2 }}>
              <Typography
                align={"center"}
                sx={{ fontWeight: "bold", fontSize: "20px" }}
              >
                Имя Фамилия
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: "14px", color: "rgb(0 0 0/0.75)", mb: 1 }}
                align={"center"}
              >
                {phoneNumber}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              borderRadius: "20px",
              backgroundColor: "rgb(255 255 255)",
              pt: "10px",
            }}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              sx={{
                pt: 1,
                pr: 2,
                pl: 1,
              }}
              onClick={() => {
                setView("visits");
              }}
            >
              <BusinessCenterIcon sx={{ p: 2, color: "rgb(0 0 0/0.75)" }} />
              <Typography fontSize={"18px"} sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                Мои визиты
              </Typography>
            </Stack>
            <Stack
              direction={"row"}
              alignItems={"center"}
              sx={{
                pt: 1,
                pr: 2,
                pl: 1,
              }}
              onClick={onLogout}
            >
              <LogoutOutlined sx={{ p: 2, color: "rgb(0 0 0/0.75)" }} />
              <Typography fontSize={"18px"} sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                Выйти
              </Typography>
            </Stack>
          </Box>
        </Box>
      );
    } else if (view == "visits") {
      element = (
        <Box
          sx={{
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: "100%",
              position: "fixed",
              top: 0,
              backgroundColor: "#fff",
              // display: { xs: 'flex', sm: 'none'},
              zIndex: 1301, // greate than swipable drawer 1300
            }}
          >
            <Icon
              onClick={() => {
                setView("account");
              }}
              sx={{
                "&:hover": {
                  cursor: "pointer",
                  backgroundColor: "#000",
                  color: "#fff",
                },
                p: "3px",
                backgroundColor: "#eee",
                borderRadius: "8px",
                position: "fixed",
                top: "40px",
                left: "25px",
              }}
            >
              <ArrowBack />
            </Icon>
            <Stack
              sx={{
                pt: "100px",
                pl: "10px",
                pr: "20px",
                pb: "10px",
              }}
              direction={"row"}
              spacing={1}
            >
              <Chip
                sx={{
                  fontSize: "16px",
                  backgroundColor: servicesStatus == "active" ? "#aaa" : "",
                }}
                size={"large"}
                label={"Активные"}
                onClick={() => {
                  setServicesStatus("active");
                }}
              ></Chip>
              <Chip
                sx={{
                  fontSize: "16px",
                  backgroundColor: servicesStatus == "notactive" ? "#aaa" : "",
                }}
                size={"large"}
                label={"Прошедшие"}
                onClick={() => {
                  setServicesStatus("notactive");
                }}
              ></Chip>
            </Stack>
          </Box>
          <ItemsList
            sx={{
              m: 1,
            }}
            items={["hello"]}
            pickedItem={servicePicked}
            handleItemPick={setServicePicked}
            getItemId={(item) => item?.id}
            getItemTitle={(item) => item?.serviceTemplate?.title}
            getItemDescription={(item) => item?.serviceTemplate.description}
            getItemImages={(item) => {
              return getImage(
                item?.serviceTemplate?.images?.map((im) => im.id),
              );
            }}
            getDetailedComponent={(item) => (
              <Stack>
                <Typography sx={{ pt: 2 }} align={"left"}>
                  Детали массажа
                </Typography>
                <Typography
                  sx={{ pt: 2 }}
                  align={"left"}
                >{`Место: ${item?.location?.title}, ${item?.location?.address}`}</Typography>
                <Typography sx={{ pt: 2 }} align={"left"}>
                  Дата и время: {item?.timeFrame?.from}
                </Typography>

                {/*<Chat*/}
                {/*    messages={ item?.logs?.map(log => ({id: log.id, text: log.message})) }*/}
                {/*    addMessage={(message) => { item?.logs?.push(message) }}*/}
                {/*/>*/}

                <Button sx={{ mt: 4 }} variant={"contained"}>
                  Отменить
                </Button>
              </Stack>
            )}
            getShortComponent={(item) => {}}
          />
        </Box>
      );
    } else if (view == "detailed") {
      element = (
        <Box
          sx={{
            position: "relative",
          }}
        >
          <Icon
            onClick={() => {
              setView("account");
            }}
            sx={{
              "&:hover": {
                cursor: "pointer",
                backgroundColor: "#000",
                color: "#fff",
              },
              p: "3px",
              backgroundColor: "#eee",
              borderRadius: "8px",
              position: "fixed",
              top: "40px",
              left: "25px",
            }}
          >
            <ArrowBack />
          </Icon>
          <Stack
            sx={{
              pt: "100px",
              pl: "20px",
              pr: "20px",
            }}
            direction={"row"}
          >
            <Chip
              sx={{ fontSize: "16px" }}
              size={"large"}
              label={"Активные"}
              onClick={() => {}}
            ></Chip>
            <Chip
              sx={{ fontSize: "16px" }}
              size={"large"}
              label={"Прошедшие"}
              onClick={() => {}}
            ></Chip>
          </Stack>
          <Stack sx={{ pt: 2 }}>
            {services.data.map((service) => (
              <Card
                elevation={1}
                sx={{ display: "flex", m: 1 }}
                onBlur={() => {}}
                onClick={() => {}}
              >
                <Box sx={{ position: "relative" }}>
                  <CardMedia
                    sx={{ width: 100, height: 100, p: 1, borderRadius: "15px" }}
                    component="img"
                    image={service?.serviceTemplate?.images}
                    alt=""
                  />
                </Box>
                <CardContent>
                  <Typography align="left" sx={{ pb: 2, fontSize: "18px" }}>
                    {service?.serviceTemplate?.title}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Box>
      );
    }

    return element;
  };

  const [itemDetailedPassed, setItemDetailedPassed] = useState(null);
  const DEFAULT_CHATS_STATE = {
    isLoading: false,
    data: [],
  };
  const [chats, setChats] = useState(DEFAULT_CHATS_STATE);

  async function loadChats() {
    let url = `/api/v1/chats/get-chats`;

    setChats((prevState) => ({ ...prevState, isLoading: true }));

    try {
      const resp = await axios.post(url, {});
      setChats({ isLoading: false, data: resp.data });
    } catch (err) {
      throw err;
    }
  }

  useEffect(() => {
    loadChats();
  }, []);

  const [chatDetailed, setChatDetailed] = useState(null);

  return (
    <App
      top={
        <Stack
          spacing={3}
          direction="row"
          sx={{
            backgroundColor: "#fcfcfc",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
            isolation: "isolate",
            display: "flex",
            flexGrow: 0,
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <Typography>Чаты</Typography>
        </Stack>
      }
    >
      {/*<Box sx={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}} >*/}
      {/*    <Typography color={"gray"}>Чатов пока нет</Typography>*/}
      {/*</Box>*/}
      <Grid container>
        <Grid item md={3} lg={2} xs={12}>
          <Box>
            <ItemsListV2
              items={
                chats?.data?.length
                  ? chats?.data?.map((item) => (
                      <Card
                        // elevation={1}
                        // key={item.id}
                        // sx={{display: 'flex', '&:hover':  { border: '1px solid #2999ff'}, '&:focus': {outline: 'none'}}}
                        sx={{ border: "none" }}
                        onClick={() => {
                          setChatDetailed(item);
                          // handleServicePick(item);
                        }}
                      >
                        <CardActionArea
                          disableRipple
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                          }}
                          onClick={() => {
                            // handleServicePick(item)
                          }}
                        >
                          <CardMedia
                            component="img"
                            sx={{
                              width: 75,
                              height: 75,
                              p: 1,
                              borderRadius: "50%",
                              // ...(now() > item?.timeFrame?.to && {opacity: '0.5'})
                            }}
                            image={getImageV2(
                              item?.images?.map((im) => im.id)[0],
                            )}
                            alt=""
                          />
                          <CardContent
                            sx={{
                              display: "block",
                              flexGrow: 1,
                              alignSelf: "stretch",
                              borderBottom: "1px solid #e3e3e3",
                            }}
                          >
                            <Stack>
                              <Typography
                                align={"left"}
                                sx={{ color: "black" }}
                              >
                                {" "}
                                {item?.title}{" "}
                              </Typography>
                              <Typography
                                align={"left"}
                                sx={{ fontSize: "12px", color: "gray" }}
                              >
                                {" "}
                                {`Последнее собщение в чате`}{" "}
                              </Typography>
                            </Stack>

                            {
                              // now() > item?.timeFrame?.to ? <Typography sx={{fontSize: '12px'}} align={'left'}>прошедший </Typography> : null
                            }
                            {/*<Typography sx={{fontSize: '16px'}} align={'left'}> { item?.serviceTemplate?.title }</Typography>*/}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    ))
                  : null
              }
              itemsLoading={chats.isLoading}
              closeDetailed={() => {
                setChatDetailed(null);
              }}
              itemDetailed={
                chatDetailed ? (
                  <Box sx={{ backgroundColor: "#fff" }}>
                    <Chat
                      chatClientId={id}
                      messages={messages?.data?.map((m) => ({
                        id: m?.id,
                        text: m?.text,
                        sender: m?.clientId,
                      }))}
                      getMessages={() => {}}
                      addMessage={(text) => {
                        handleSendMessage(chatDetailed?.id, text);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                  </Box>
                ) : null
              }
            />
          </Box>
        </Grid>
      </Grid>
    </App>
  );
};

export default ChatScreen;
